import * as Product from '@/services/rest-api/lib/invoice/product'

export default {
  computed: {
    serviceCostFields() {
      return [
        {
          name: 'id',
          key: 'product.name',
          label: this.$t('invoice.fields.serviceName'),
          placeholder: this.$t('invoice.fields.serviceName'),
          isEditable: true,
          isShow: true,
          validation: 'required',
          type: 'select-resourceful-v2',
          trackBy: 'id',
          displayedBy: 'name',
          optionsGetter: Product.getExternal,
          optionLabelFn: ({ item }) => item.name,
          thStyle: 'width: 200px'
        },
        {
          name: 'delivery_order_id',
          key: 'delivery_order.number',
          label: this.$t('invoice.fields.costRelation'),
          placeholder: this.$t('global.action.choose'),
          type: 'value-help-v2',
          trackBy: 'id',
          displayedBy: 'number',
          isEditable: true,
          isShow: true,
          thStyle: 'width: 150px',
        },
        {
          name: 'sales_order_number',
          key: 'sales_order_number',
          label: this.$t('invoice.fields.salesOrderNumber'),
          type: 'text',
          isEditable: false,
          isShow: true,
          thStyle: 'width: 150px',
        },
        {
          name: 'description',
          key: 'description',
          label: this.$t('invoice.fields.description'),
          placeholder: this.$t('invoice.fields.description'),
          type: 'text',
          isEditable: true,
          isShow: true,
          thStyle: 'width: 200px'
        },
        {
          name: 'quantity',
          key: 'quantity',
          label: this.$t('invoice.fields.quantity'),
          _type: 'number',
          placeholder: this.$t('invoice.placeholder.quantity'),
          validation: 'bail|required|number|min:1,value|max:1000000,value|integer',
          'validation-messages': {
            min: this.$t('global.validation.minPositiveOnly')
          },
          isEditable: true,
          isShow: true,
          thStyle: 'width: 100px'
        },
        {
          name: 'unit_price',
          key: 'unit_price',
          label: this.$t('invoice.fields.price'),
          _type: 'number',
          placeholder: this.$t('invoice.placeholder.price'),
          validation: 'bail|required|number|min:1,value|max:100000000000,value',
          'validation-messages': {
            min: this.$t('global.validation.minPositiveOnly')
          },
          isEditable: true,
          isShow: true,
          thStyle: 'width: 200px',
          tdClass: 'mc-amount-col-head'
        },
        {
          name: 'discount',
          key: 'discount',
          label: this.$t('invoice.fields.discount'),
          _type: 'number',
          placeholder: this.$t('invoice.placeholder.discount'),
          validation: 'bail|required|number|min:0,value|max:100000000000,value|discount',
          'validation-messages': {
            discount: ({ name }) => `${this.$t(name)} ${this.$t('invoice.validation.discount')}`,
            min: this.$t('global.validation.minPositiveOnly')
          },
          validationRules: {
            discount({ value, getFormValues }) {
              const { quantity, unit_price } = getFormValues()
              if (value > (quantity * unit_price)) {
                return false
              }
              return true
            },
          },
          isEditable: true,
          isShow: true,
          value: 0,
          thStyle: 'width: 150px',
          tdClass: 'mc-amount-col-head'
        },
        {
          name: 'tax',
          key: 'tax',
          label: this.$t('invoice.fields.tax'),
          placeholder: this.$t('invoice.fields.tax'),
          _type: 'number',
          validation: 'bail|required|number|min:1,value|max:100000000000,value|integer',
          'validation-messages': {
            min: this.$t('invoice.validation.min')
          },
          isEditable: true,
          isShow: false,
          thStyle: 'width: 100px',
          tdClass: 'mc-amount-col-head'
        },
        {
          name: 'total_price',
          key: 'total_price',
          label: this.$t('invoice.fields.totalPrice'),
          _type: 'number',
          validation: 'bail|required|number|min:1,value|max:100000000000,value|integer',
          'validation-messages': {
            min: this.$t('invoice.validation.min')
          },
          isEditable: false,
          isShow: true,
          value: 0,
          thStyle: 'width: 100px',
          tdClass: 'mc-amount-col-head'
        },
      ]
    }
  }
} 
